import React from "react";
import { Link } from "react-router-dom";

interface PageHeaderProps {
    cycleYear: number;
    setCycleYear: (year: number) => void;
    yearOptions: number[];
    isPastYear: boolean;
    currentYear: number;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
    cycleYear,
    setCycleYear,
    yearOptions,
    isPastYear,
    currentYear,
}) => {
    return (
        <>
            {/* Link Voltar */}
            <Link
                to="/backoffice/perfil-clientes"
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "13px",
                    color: "#64748b",
                    textDecoration: "none",
                    marginBottom: "20px",
                }}
            >
                <span style={{ fontSize: "15px" }}>←</span> Voltar para Perfis de Cliente
            </Link>

            {/* Título da Página e Seleção de Ciclo */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "16px",
                    marginBottom: "24px",
                    flexWrap: "wrap",
                }}
            >
                <div style={{ display: "flex", alignItems: "flex-start", gap: "14px" }}>
                    <div>
                        <div style={{ fontSize: "24px", fontWeight: 700, color: "#1e293b", lineHeight: 1.2 }}>
                            Edição Massiva de Reajuste
                        </div>
                        <div style={{ fontSize: "14px", color: "#64748b", marginTop: "4px" }}>
                            Visualize e aplique percentuais de reajuste por cliente e por ciclo.
                        </div>
                    </div>
                </div>

                <div style={{ display: "flex", alignItems: "flex-end", gap: "10px" }}>
                    <div>
                        <label
                            style={{
                                fontSize: "11.5px",
                                fontWeight: 600,
                                color: "#64748b",
                                display: "block",
                                marginBottom: "5px",
                            }}
                        >
                            Ciclo (ano)
                        </label>
                        <select
                            value={cycleYear}
                            onChange={(e) => setCycleYear(Number(e.target.value))}
                            style={{
                                padding: "10px 14px",
                                border: `1px solid ${isPastYear ? "#fed7aa" : "#e2e8f0"}`,
                                borderRadius: "9px",
                                fontSize: "14px",
                                fontWeight: 600,
                                color: isPastYear ? "#92400e" : "#1e293b",
                                background: isPastYear ? "#fff7ed" : "#fff",
                                cursor: "pointer",
                            }}
                        >
                            {yearOptions.map((y) => (
                                <option key={y} value={y}>
                                    {y}
                                    {y < currentYear ? " (somente leitura)" : ""}
                                </option>
                            ))}
                        </select>
                        {isPastYear && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    marginTop: "5px",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: "#d97706",
                                }}
                            >
                                <svg
                                    width="11"
                                    height="11"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#d97706"
                                    strokeWidth="2.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                </svg>
                                Somente leitura
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
